var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBabyWell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 770681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.2417 13.3706C29.2417 14.6423 28.5001 16.5 26.6879 16.6474C25.1442 21.4914 20.6079 25 15.2522 25C9.89643 25 5.3601 21.4914 3.81643 16.6474C2.5001 16.5 1.39384 15.5754 0.999991 14C0.5 12 1.57183 10.2836 3.56086 10.2836C4.7918 4.96465 9.55902 1 15.2522 1C20.9453 1 25.7125 4.96465 26.9435 10.2836C29.0001 10.2836 29.2417 12.4364 29.2417 13.3706Z",
    stroke: "#7A9198",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.95395 11.8082C9.35654 11.8097 8.8711 11.3266 8.86975 10.7292C8.86826 10.1319 9.35131 9.64666 9.94857 9.64516C10.5416 9.64366 11.0251 10.12 11.0328 10.7129C11.0328 11.3115 10.5523 11.7992 9.95395 11.8082Z",
    fill: "#7A9198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6621 10.7226C21.6636 11.319 21.1813 11.804 20.5846 11.8053C19.9881 11.807 19.5032 11.3245 19.5017 10.728C19.5002 10.1314 19.9827 9.64666 20.5791 9.64516H20.5819C21.1828 9.65264 21.665 10.1435 21.6621 10.7445V10.7226Z",
    fill: "#7A9198"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3039",
    d: "M10.668 17.2961C10.668 17.2961 12.1124 19.222 15.0013 19.222C17.8902 19.222 19.3346 17.2961 19.3346 17.2961",
    stroke: "#7A9198",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3129",
    d: "M15.0001 1.5C13.0846 2.47725 11.873 6.84445 15.1159 7.39726C18.3588 7.95007 17.96 4.17142 16.6431 3.80949",
    stroke: "#7A9198",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabyWell);
export default __webpack_public_path__ + "static/media/baby-well.91b2933ac105a7a52bb27f08c1bad3a6.svg";
export { ForwardRef as ReactComponent };